/**
 * banner列表页
 */
export const BANNER_LIST_PAGE_PATH = '/pc/banner/list'

/**
 * banner新增页
 */
export const BANNER_CREATE_PAGE_PATH = '/pc/banner/create'

/**
 * banner编辑页
 */
export const BANNER_EDIT_PAGE_PATH = '/pc/banner/edit'
